<div class="flex flex-col h-full space-y-8">
    <h1 class="text-2xl">Reports</h1>

    <div class="flex flex-col space-y-4">
        @if (shouldDisplayQuickbooksReport()) {
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        class="!text-tertiary-900 font-normal text-xl py-2"
                    >
                        <h2
                            class="!text-tertiary-900 font-normal !text-xl !m-0"
                        >
                            QuickBooks
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <app-quickbooks-report />
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        class="!text-tertiary-900 font-normal text-xl py-2"
                    >
                        <h2
                            class="!text-tertiary-900 font-normal !text-xl !m-0"
                        >
                            Accounting Review
                        </h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <app-accounting-review-report />
            </mat-expansion-panel>
        }

        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-xl py-2"
                >
                    <h2 class="!text-tertiary-900 font-normal !text-xl !m-0">
                        Prepaid NT Query
                    </h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-xl py-2"
                >
                    <h2 class="!text-tertiary-900 font-normal !text-xl !m-0">
                        PowerBI
                    </h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-xl py-2"
                >
                    <h2 class="!text-tertiary-900 font-normal !text-xl !m-0">
                        Advisor Statistics
                    </h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
        </mat-expansion-panel>
    </div>
</div>
